import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExternalSystemSyncLogEntry  {
    _originalTypeClassName = "zERP.BO.ExternalSystemSyncLogEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExternalSystemSyncLogEntry.translate = translateService;
}
this.Id = null;
this.Message = null;
this.Severity = null;
this.RelatedInvoiceId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Message:any;
Severity:any;
RelatedInvoiceId:any;
Execution:any;
static setExecution = ($this, value) => {
var oldValue = $this.Execution;
$this.Execution = value;
if (value != null) {
if (oldValue != null) {
Domain.ExternalSystemSyncExecution.removeLogs(oldValue, $this);
}
Domain.ExternalSystemSyncExecution.addLogs(value, $this);
}
}

static Init(message: any,severity: any,relatedInvoiceId: any): any{let log = new Domain.ExternalSystemSyncLogEntry();
log.Message = message;
log.Severity = severity;
log.RelatedInvoiceId = relatedInvoiceId;
return log;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}